
function DocsContent({ sections }) {
  return (
    <div>
      {sections.map(section => (
        <div key={section.id} id={section.id} className="mb-5">
          <h2>{section.title}</h2>
          {section.chapters.map(ch => (
            <div key={ch.id} id={ch.id} className="mb-4 ps-3 border-start">
              <h4>{ch.title}</h4>
              <p style={{ whiteSpace: "pre-line" }}>{ch.body}</p>
              {ch.widget && (
                <div className="mt-3">{ch.widget}</div>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default DocsContent;
